import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { FaCommentDots } from "react-icons/fa";

const Feedback = () => {
  const [num1, setNum1] = useState(0);
  const [num2, setNum2] = useState(0);
  const [captcha, setCaptcha] = useState("");

  const generateCaptcha = () => {
    setNum1(Math.floor(Math.random() * 9) + 1);
    setNum2(Math.floor(Math.random() * 9) + 1);
    setCaptcha("");
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (Number(captcha) !== num1 + num2) {
      alert("Incorrect Captcha!");
      generateCaptcha();
      return;
    }

    alert("Feedback Submitted Successfully!");
    generateCaptcha();
  };

  return (
    <section className="bg-white py-20">

      <div className="max-w-4xl mx-auto px-6">

        {/* Heading */}

        <div className="text-center mb-16">

          <div className="w-20 h-20 mx-auto rounded-full bg-[#07294d] flex items-center justify-center text-white text-3xl mb-6">

            <FaCommentDots />

          </div>

          <p className="uppercase tracking-[6px] text-[#d4af37] font-bold mb-4">
            Cambridge International School
          </p>

          <h1 className="text-5xl md:text-6xl font-black text-[#07294d]">
            Feedback Form
          </h1>

          <div className="w-24 h-1 bg-[#d4af37] rounded-full mx-auto my-8"></div>

          <p className="max-w-2xl mx-auto text-lg text-gray-600 leading-9">
            Please fill the form given below and we will get in touch
            with you shortly.
          </p>

        </div>

        {/* Form */}

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          viewport={{ once: true }}
          className="bg-[#f8fafc] rounded-[30px] border border-gray-100 shadow-lg p-10"
        >

          <form
            onSubmit={handleSubmit}
            className="grid md:grid-cols-2 gap-6"
          >

            {/* Name */}

            <div>

              <label className="block mb-2 font-semibold text-[#07294d]">

                Name

              </label>

              <input
                type="text"
                placeholder="Enter Your Name"
                className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:border-[#07294d]"
              />

            </div>

            {/* Subject */}

            <div>

              <label className="block mb-2 font-semibold text-[#07294d]">

                Subject

              </label>

              <input
                type="text"
                placeholder="Enter Subject"
                className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:border-[#07294d]"
              />

            </div>

            {/* Email */}

            <div className="md:col-span-2">

              <label className="block mb-2 font-semibold text-[#07294d]">

                Email

              </label>

              <input
                type="email"
                placeholder="Enter Email Address"
                className="w-full border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:border-[#07294d]"
              />

            </div>

            {/* Message */}

            <div className="md:col-span-2">

              <label className="block mb-2 font-semibold text-[#07294d]">

                Message

              </label>

              <textarea
                rows="6"
                placeholder="Write your feedback..."
                className="w-full border border-gray-300 rounded-xl px-4 py-3 resize-none focus:outline-none focus:border-[#07294d]"
              ></textarea>

            </div>
                        {/* Captcha */}

            <div>

              <label className="block mb-2 font-semibold text-[#07294d]">

                Captcha

              </label>

              <div className="flex items-center gap-3">

                <div className="min-w-[90px] h-[52px] rounded-xl bg-[#07294d] text-white font-bold flex items-center justify-center text-lg">

                  {num1} + {num2}

                </div>

                <input
                  type="number"
                  value={captcha}
                  onChange={(e) => setCaptcha(e.target.value)}
                  placeholder="Enter Answer"
                  className="flex-1 border border-gray-300 rounded-xl px-4 py-3 focus:outline-none focus:border-[#07294d]"
                />

              </div>

            </div>

            {/* Empty Grid Space */}

            <div></div>

            {/* Submit Button */}

            <div className="md:col-span-2 text-center pt-6">

              <button
                type="submit"
                className="bg-[#07294d] hover:bg-[#0b3d69] text-white px-12 py-4 rounded-full font-semibold transition duration-300 shadow-lg"
              >
                Submit Feedback
              </button>

            </div>

          </form>

        </motion.div>

      </div>

    </section>
  );
};

export default Feedback;